import { MongoTeamId } from "@redotech/redo-model/mongo-ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";
import { BackfillMessageChannelSchema } from "./get-support-backfill-messages";

export const TriggerSupportV2EmailBackfillResult = z.object({
  teamId: MongoTeamId.schema,
  success: z.boolean(),
  message: z.string(),
  workflowId: z.string().optional(),
  integrationId: z.string().optional(),
  email: z.string().optional(),
});
export type TriggerSupportV2EmailBackfillResult = z.infer<
  typeof TriggerSupportV2EmailBackfillResult
>;

export const triggerSupportV2EmailBackfill = unaryRpc({
  name: "triggerSupportV2EmailBackfill" as const,
  input: z.object({
    teamIds: z.array(MongoTeamId.schema).min(1),
    channel: BackfillMessageChannelSchema,
    days: z.number().int().min(1).max(365),
  }),
  output: z.object({ results: z.array(TriggerSupportV2EmailBackfillResult) }),
});

export type TriggerSupportV2EmailBackfillInput = z.infer<
  typeof triggerSupportV2EmailBackfill.input
>;

export type TriggerSupportV2EmailBackfillOutput = z.infer<
  typeof triggerSupportV2EmailBackfill.output
>;
